import React from 'react'
import { Option, OptionsWrap } from '../index.styled'

const Options = ({ options, onClick }) => {

	return (
		<OptionsWrap>
			{options?.map((item, i) =>
				<Option key={i} data-name={item.value} onClick={() => onClick(item)}>{item.label}</Option>)}
		</OptionsWrap>
	)
}

Options.displayName = 'Options'
export default Options
